import { AuditEntity } from "@app/common";
import { Api, Column, Display, FormField, FormFieldType, prop, required, Table } from "@messaia/cdk";

@Api('faq')
@Table({ includes: ['Client'] })
export class Faq extends AuditEntity {
	@required()
	@FormField({ row: 2 })
	@Column({ content: (x: Faq) => x?.question })
	@Display($localize`:@@question:Question`)
	question: string;

	@required()
	@FormField({
		row: 3, type: FormFieldType.Autocomplete, options: [
			{ id: 'Bills', name: 'Bills' },
			{ id: 'Contracts', name: 'Contracts' },
			{ id: 'Orders', name: 'Orders' },
			{ id: 'Profile', name: 'Profile' },
		]
	})
	@Column({ maxWidth: 150, showGtLg: true })
	@Display($localize`:@@group:Group`)
	group: string;

	@FormField({ row: 1, endpoint: 'client?enabled=true&projection=id,name' })
	@Column({
		name: 'client.displayName',
		endpoint: 'client?enabled=true&projection=id,name',
		maxWidth: 250,
		showGtXl: true
	})
	@Display($localize`:@@client:Client`)
	@required()
	clientId: number;

	@prop()
	@FormField({ row: 3 })
	@Display($localize`:@@ordering:Ordering`)
	ordering: number;

	@required()
	@FormField({ row: 4, type: FormFieldType.Editor })
	@Display($localize`:@@answer:Answer`)
	answer: string;

	@prop()
	@FormField({ row: 5 })
	@Column({ event: 'toggle' })
	@Display($localize`:@@enabled:Enabled`)
	enabled: boolean;

	/**
	 * constructor
	 * @param init 
	 */
	public constructor(init?: Partial<Faq>) {
		super(init);
		Object.assign(this, init);
	}
}